
export default {
    namespaced: true,
    state: {
        timeout: -1,
        text: null,
        subtext: null,
        shown: false,
        color: null,
    },
    getters: {
        shown(state) {
            return state.shown;
        },
        color(state) {
            return state.color;
        },
        text(state) {
            return state.text;
        },
        subtext(state) {
            return state.subtext;
        },
        timeout(state) {
            return state.timeout;
        },
    },
    mutations: {
        shown(state, shown) {
            state.shown = shown;
        },
        hide(state) {
            state.shown = false;
        },
        display(state, { timeout, text, subtext, color }) {
            state.text = text;
            state.subtext = subtext;
            state.timeout = timeout;
            state.color = color;
            state.shown = true;
        },
    },
};
